<template>
  <section class="page login">
    <div class="login__background">
      <img :src="$cdn + '/images/background-banner.jpg'" alt="background banner">
    </div>
    <b-container fluid="xl">
      <b-row>
        <b-col>
          <div class="login__container">
            <div class="login__content">
              <div class="login__section">PROVEEDORES</div>
              <div class="login__main">
                <a href="https://cajasan.com" target="_blank" rel="noopener noreferrer" class="login__link">
                  <b-icon icon="house-door-fill"></b-icon>
                </a>
                <formularioLogin/>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <footerCustom />
    <Cargando />
  </section>
</template>

<script>
import formularioLogin from '@/components/forms/formLogin.vue'
import footerCustom from '@/components/ui/footer.vue'
import Cargando from "../../../../cajasan.ui/src/src/components/ui/Cargando";

export default {
  name: 'loginCustom',
  data () {
    return {
      state: 'login'
    }
  },
  components: {
    formularioLogin,
    footerCustom,
    Cargando
  }
}
</script>
